import { IDisplayMode } from "../../interfaces/IDisplayMode";

export let initialState: { displayMode: IDisplayMode } = {
  displayMode: IDisplayMode.CARD,
};

const getDefaultState = () => ({
  displayMode: IDisplayMode.CARD,
});

export type IState = typeof initialState;

export enum IAction {
  UPDATE_INPUT = "update_input",
}

export const componentIsUnmounting = () => {
  initialState = getDefaultState();
};

const actionHandlers = Object.fromEntries(
  Object.values(IAction).map((action) => [action, (_: IState, payload: IState) => ({ ...payload })])
);

export function reducer(state: IState, { type, payload }: { type: IAction; payload: IState }): IState {
  const actionHandler = actionHandlers[type] || ((state) => state);
  return actionHandler(state, payload);
}
